<template>
  <div
    class="gto-dashboard sttdplans medium-scroll-track"
    style="min-height: 0"
  >
    <div class="sttdplans_content">
      <div class="sttdplans_content_top no-events">
        <DashboardArticle
          :item="item"
          componentTag="div"
          class="dasarttcsl_reversed mt-12 w-100"
          style="
            --line-clamp: 66;
            --line-clamp-title: 24;
            --title-line-height: 1.2;
            --title-overflow: unset;
            --text-overflow: unset;
            --clr-back: transparent;
            --title-font-size: var(--dash-title-font-size);
            --description-font-size: var(--dash-description-font-size);
            --description-margin: 1.75rem 0 1rem 0;
            overflow: unset;
            --clr-bolded: var(--clr-primary);
            --left-overflow: unset;
          "
        >
          <template #left>
            <component
              :is="'PcScreensSvgV1'"
              class="w-100 sttdplans_content_top_svg anim-fade-in_slow"
            />
            <!-- <div class="gw-icon-gwizstudyplans"></div> -->
          </template>
          <template #description="v">
            <div class="sttdplans_spantext">
              <span v-html="v.item.description"></span>
            </div>
          </template>
        </DashboardArticle>
      </div>
      <div
        class="sttdplans_content_plans"
        style="z-index: 4"
      >
        <!-- <div class="text-large weight_600">
          {{ $t('study_plans.start_studying') }}
        </div> -->
        <StudyPlans />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardArticle from '@/components/Dashboard/DashboardArticle'
import PcScreensSvgV1 from '@/assets/svg/pcscreensv1.svg'
import StudyPlans from '@/components/StudyPlans/StudyPlans'

export default {
  name: 'StudyPlansDashboard',
  components: {
    StudyPlans,
    DashboardArticle,
    PcScreensSvgV1,
  },
  data() {
    return {}
  },

  computed: {
    item() {
      const res = {
        id: 'none',
        title: this.$t('study_plans.title'),
        description: this.$t('study_plans.description'),
        url: '',
      }

      // console.log('item', res)
      return res
    },

    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>
<style lang="scss" scoped>
.sttdplans {
  display: flex;
  min-height: var(--vh-3);
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  flex-direction: column;
  --dash-title-font-size: 4rem;
  --dash-description-font-size: 1.5rem;
  &_content {
    margin: 0 auto;
    padding: 2.5rem 0.5rem;
    width: clamp(12rem, 75.5rem, 100vw);
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
    &_top {
      &_svg {
        transform: scale(1.7);
        left: -22%;
        top: 7%;
        position: relative;
      }
    }
    &_plans {
      display: flex;
      flex-direction: column;
    }
  }
}

@media (max-width: 1260px) {
  .sttdplans {
    &_content {
      &_top {
        padding: 0 1rem;
        &_svg {
          transform: scale(1.6);
          left: 0;
          top: 0;
        }
      }
    }
  }
}

@media (max-width: 770px) {
  .sttdplans_spantext {
    background: rgba(18, 18, 18, 0.95);
    border-radius: 4px;
    padding: 0.75rem;
  }
  .sttdplans {
    --dash-title-font-size: 3rem;
    --dash-description-font-size: 1.25rem;
    &_content {
      &_top {
        padding: 0 1rem;
        &_svg {
          transform: scale(2);
          margin-bottom: 4rem;
          left: 0;
          top: 0;
        }
      }
    }
  }
}
</style>
